// extracted by mini-css-extract-plugin
module.exports = {"Tmap":"TMAP_Tmap__2iCuw","Public":"TMAP_Public__1Y1Wv"};